import type { App } from 'vue'
import { canAccessFeature } from '@/vue/composables/use-can-access-feature'

// @ts-expect-error baseline
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $canAccessFeature: typeof canAccessFeature
    }
}

export default {
    install: (app: App): void => {
        // @ts-expect-error baseline
        app.config.globalProperties.$canAccessFeature = canAccessFeature
    },
}
